import { useOutletContext } from "react-router-dom";

import OngoingProductionsView from "../views/OngoingProductions/OngoingProductionsView";

export default function OngoingProductions() {
	const { organization } = useOutletContext();

	return <OngoingProductionsView organization={organization} />;
}
